import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Utensils, Shirt, Sparkles, Palette, Briefcase } from 'lucide-react';

const CATEGORY_DATA = [
  {
    key: 'food',
    icon: Utensils,
    color: '#E31C25',
    image: 'https://images.pexels.com/photos/17952748/pexels-photo-17952748.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    span: 'md:col-span-4 lg:col-span-5',
    tall: true,
  },
  {
    key: 'fashion',
    icon: Shirt,
    color: '#008751',
    image: 'https://images.pexels.com/photos/10452412/pexels-photo-10452412.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    span: 'md:col-span-4 lg:col-span-7',
    tall: true,
  },
  {
    key: 'beauty',
    icon: Sparkles,
    color: '#E31C25',
    image: 'https://images.pexels.com/photos/7382940/pexels-photo-7382940.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    span: 'md:col-span-4 lg:col-span-6',
    tall: false,
  },
  {
    key: 'arts',
    icon: Palette,
    color: '#008751',
    image: 'https://images.pexels.com/photos/36697628/pexels-photo-36697628.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    span: 'md:col-span-4 lg:col-span-6',
    tall: false,
  },
  {
    key: 'services',
    icon: Briefcase,
    color: '#09090B',
    image: 'https://images.pexels.com/photos/8549944/pexels-photo-8549944.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    span: 'md:col-span-8 lg:col-span-12',
    tall: false,
  },
];

export default function Categories() {
  const { t } = useLanguage();

  return (
    <section id="categories" className="py-24 sm:py-32" data-testid="categories-section">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="max-w-2xl mb-16">
          <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#008751] block mb-4">
            {t('categories.label')}
          </span>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-bold mb-4"
            style={{ fontFamily: 'Outfit, sans-serif' }}
            data-testid="categories-title"
          >
            {t('categories.title')}
          </h2>
          <p className="text-base lg:text-lg leading-relaxed text-zinc-600">
            {t('categories.subtitle')}
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-8 lg:grid-cols-12 gap-4 lg:gap-6" data-testid="categories-grid">
          {CATEGORY_DATA.map((cat) => {
            const Icon = cat.icon;

            return (
              <div
                key={cat.key}
                className={`${cat.span} group relative overflow-hidden rounded-3xl border border-zinc-100 bg-white
                  ${cat.tall ? 'min-h-[280px] lg:min-h-[360px]' : 'min-h-[200px] lg:min-h-[240px]'}
                  transition-all duration-300 hover:shadow-[0_8px_30px_rgb(0,0,0,0.08)] hover:-translate-y-1 hover:border-black/10 cursor-pointer`}
                data-testid={`category-${cat.key}`}
              >
                <img
                  src={cat.image}
                  alt={t(`categories.items.${cat.key}`)}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                <div className="relative z-10 flex flex-col justify-end h-full p-8 lg:p-10">
                  <Icon className="w-6 h-6 text-white/80 mb-3" />
                  <h3 className="text-xl lg:text-2xl font-bold text-white" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    {t(`categories.items.${cat.key}`)}
                  </h3>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
